export default __webpack_public_path__ + "images/c12c094a1dba30b5eb6d0a5fa00da420-golf.jpg";